module.exports = __webpack_public_path__ + "img/google-play-logo.08542109.png";